// src/context/AppContext.js
import React, { createContext, useState, useContext } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/system';
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";

const AppContext = createContext();

export const DashAppProvider = ({ children }) => {
    const [selectedFamily, setSelectedFamily] = useState("30RB");
    const [open, setOpen] = useState(false);

    const CustomTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))({
        [`& .MuiTooltip-tooltip`]: {
            fontSize: '1rem', // Larger font size for the tooltip text
        },
    });

    return (
        <AppContext.Provider value={{
            setOpen,
            CustomTooltip,
            selectedFamily,
            setSelectedFamily,
        }}>
            <Backdrop
                sx={{ color: "black", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
            >
                <CircularProgress size="4rem" color="primary" />
            </Backdrop>
            {children}
        </AppContext.Provider>
    );
};

export const useAppContext = () => useContext(AppContext);
